/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyCreateRequestDto
 */
export interface CompanyCreateRequestDto {
  /**
   *
   * @type {string}
   * @memberof CompanyCreateRequestDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CompanyCreateRequestDto
   */
  avatarImageId: string | null;
}

export function CompanyCreateRequestDtoFromJSON(json: any): CompanyCreateRequestDto {
  return CompanyCreateRequestDtoFromJSONTyped(json, false);
}

export function CompanyCreateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyCreateRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
    avatarImageId: json["avatarImageId"],
  };
}

export function CompanyCreateRequestDtoToJSON(value?: CompanyCreateRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
    avatarImageId: value.avatarImageId,
  };
}
